module.exports = __webpack_public_path__ + "img/gg-bg.e82efa98.png";